import { Locale } from "modules/i18n/config/locale"
import { getRuntimeConfig } from "common/lib/runtimeConfig"
import { RefObject } from "react"
import ReCAPTCHA from "react-google-recaptcha"

const googleRecaptchaSiteKey = (): string => getRuntimeConfig().GOOGLE_RECAPTCHA_SITE_KEY

export const isEnvEnabled = (): boolean =>
  process.env.NEXT_PUBLIC_GOOGLE_RECAPTCHA_ENABLED == "true"

interface RecaptchaValidationProps {
  locale: Locale
  recaptchaRef?: RefObject<ReCAPTCHA | null>
}

export const RecaptchaValidation = ({ recaptchaRef, locale }: RecaptchaValidationProps) => {
  if (!isEnvEnabled()) {
    return null
  }

  return (
    <ReCAPTCHA ref={recaptchaRef} hl={locale} sitekey={googleRecaptchaSiteKey()} size="invisible" />
  )
}
